import AuditLogsSettings from '@/pages/settings/audit-logs';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/(protected)/settings/audit-logs'
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <AuditLogsSettings />;
}
